export enum ProductTypeE {
  BANNER = 'banner',
  PRODUCT = 'product',
}

export const HITS_PER_PAGE_DESKTOP = 24

export const CAN_SHOW_PLP_ACTIONS = 'canShowPLPActions'

export const FILTER_POLARIZED = 'polarized'
export const FILTER_CUSTOMIZABLE = 'customizable'
export const NEW_RELEASES = 'newreleases'
export const FILTER_FEATURED = ['featured', NEW_RELEASES]
export const FILTER_PRESCRIPTION_AVAILABLE = 'prescription_available'
export const FILTER_EXCLUSIVE = 'exclusive'
export const FILTER_LIMITED_EDITION = 'limited_edition'
export const SORTBADGE_GUEST = 'sortBadge_Guest'
export const SORTBADGE_EARLY_ACCESS = 'sortBadge_early_access'
export const PRICE_FACET = 'PRICE'
export const PRICE_FILTER = 'xBestPrice'
export const PROMO_FILTER = 'priceFilter'
export const BRASIL_INSTALLMENTS = 'ou até 10x de'
export const CUSTOM_EVENTS_FIRST_REQUEST_ALGOLIA = 'algolia-first-request'
export const SINGLE_FILTERS = [
  FILTER_POLARIZED,
  FILTER_CUSTOMIZABLE,
  FILTER_FEATURED,
  FILTER_PRESCRIPTION_AVAILABLE,
  FILTER_EXCLUSIVE,
  FILTER_LIMITED_EDITION,
  NEW_RELEASES,
]

export const FACET_KEYS = {
  PRICE: 'PRICE',
  PROMO_FILTER: 'PROMO_FILTER',
  GENDER: 'GENDER',
  PROMO: 'PROMO',
  LIMITED_EDITION: 'LIMITED_EDITION',
  EXCLUSIVE: 'EXCLUSIVE',
  POLARIZED: 'POLARIZED',
  CUSTOMIZABLE: 'CUSTOMIZABLE',
  PRESCRIPTION_AVAILABLE: 'PRESCRIPTION_AVAILABLE',
  NEWRELEASES: 'NEWRELEASES',
  FEATURED: 'FEATURED',
  POPULAR_FILTERS: 'POPULAR_FILTERS',
  FRAME_SHAPE_FACET: 'FRAME_SHAPE_FACET',
  FACE_SHAPE: 'Face Shape',
  HIGH_PRESCRIPTION: 'HIGH_PRESCRIPTION',
  LENS_COLOR: 'LENS_COLOR_FACET',
  FRAME_COLOR: 'FRONT_COLOR_FACET',
  PRICEFILTER_GUEST: 'priceFilter_Guest',
  MODEL_SIZE_DISPLAY: 'MODEL_SIZE_DISPLAY',
}

export const FACET_VALUES = {
  UNISEX: 'Unisex',
}

export const VERTICAL_FACETS = [
  'FRAME_FIT',
  'LENS_TREATMENT_FACET',
  'FRAMEMATERIAL_FACET',
  'GEO_FIT',
]

export const COLOR_FACETS = ['LENS_COLOR_FACET', 'FRONT_COLOR_FACET']

export const DATA_MNT_FILTER_NAMES = {
  CUSTOMIZABLE: 'customizable',
  EXCLUSIVE: 'exclusive',
  'Face Shape': 'face-shape',
  FEATURED: 'featured',
  FRAME_FIT: 'frame-fit',
  FRAMEMATERIAL_FACET: 'frame-material',
  FRAME_SHAPE_FACET: 'frame-shape',
  FRONT_COLOR_FACET: 'frame-color',
  GENDER: 'gender',
  GEO_FIT: 'geo-fit',
  HIGH_PRESCRIPTION: 'high-prescription',
  LENS_COLOR_FACET: 'lens-color',
  LENS_TREATMENT_FACET: 'lens-type',
  LIMITED_EDITION: 'limited-edition',
  MODEL_SIZE_DISPLAY: 'size',
  NEWRELEASES: 'new-releases',
  POLARIZED: 'polarized',
  POPULAR_FILTERS: 'popular',
  PRESCRIPTION_AVAILABLE: 'prescription-available',
  PRICE: 'price',
  priceFilter_Guest: 'price-filter',
  PROMO: 'promo',
  PROMO_FILTER: 'promo',
}
